import type { MParentSubCategoryTreeV2 } from "@/Models/DepartamentCategory/DepartamentCategory";
import type { products } from "@/Models/MProduct/Products";
import type { MSubCategoryHijaSubcategoryV2 } from "@/Models/MSubCategories/MPLPCategory";
import { useDepartamentCategories } from "@/Service/Api/Index";
import { ReplaceCharacterRest } from "@/Utils/RemplaceCharacter";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useParams } from "react-router-dom";

type CategorieConstextType = {
  ProductsByCategory: MParentSubCategoryTreeV2[];
  IsLoadings: boolean;
  VoidDefault: (categroriesList: string) => void;
  ProductsForCategory: products[];
  ProductsForCategoryFilter: products[];
  ProductColorsCategory: string[];
  SelectBrand: string[];
  SelectBrandFilter: string[];
  HeanddleFilterBrandData: (name: string, checked: boolean) => void;
  HeanddleOrderToFilter: (event: number) => void;
  HeaddleRangePriceFilter: (min: number, max: number) => void;
  HabilitedFilters: boolean;
  // VoidDefault: (categroriesList: string) => void;
  // ListColorsDefault: string[];
  // CategoriesDefault: string;
  // UpdateSubCategories: string;
};

export const CategoriesContext = React.createContext<
  CategorieConstextType | undefined
>(undefined);

type paramCategory = { cteg?: string; subcateg?: string };

const ContextCategorieProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { cteg, subcateg } = useParams<paramCategory>();
  const [categories, setCategories] = useState<string>("electronica");
  //sort by data mark - brand
  const [SelectBrandFilter, setSelectBrandFilter] = useState<string[]>([]);
  //sort by data column
  const [OrderToColumnFilter, setOrderToColumnFilter] = useState<number>(0);
  //sort by rank - range
  const [dataRangeFilter, setDataRangeFilter] = useState<[number, number]>([
    0, 50500,
  ]);

  const { listCategory, isLoadin: IsLoadings } = useDepartamentCategories(
    //category!
    // categories === "electronica" ||
    //   categories === "" ||
    //   categories === undefined
    //   ? "electronica"
    //   : categories! //category!
    "electronica"
  );

  const VoidDefault = useCallback((categoriesList: string) => {
    setCategories(categoriesList!);
  }, []);

  //Obtenemos los que si cuentan con productos.
  const ProductsByCategory =
    listCategory && listCategory.length > 0
      ? listCategory
          ?.filter((f) => f.Id === cteg!)
          ?.flatMap((f) => f.SubCategories || [])
          ?.filter((w) => Array.isArray(w.Products) && w.Products.length > 0)
      : [];

  const ProductsForCategory: products[] =
    ProductsByCategory.filter(
      (f) => f.Id === ReplaceCharacterRest(subcateg!.toLowerCase())
    )?.flatMap((p) => p?.Products || []) ?? [];

  const HabilitedFilters = ProductsForCategory.length > 0 ? true : false;

  const ProductColorsCategory =
    ProductsForCategory.length > 0
      ? [
          ...new Set(
            ProductsForCategory.flatMap((c) =>
              c.Promotions.flatMap((o) => o.color)
            )
          ),
        ]
      : [];

  const SelectBrand = [
    ...new Set(ProductsForCategory.flatMap((m) => m.Brand.toLowerCase())),
  ];

  /********************************************************************************/
  /****************** Obtenemos los datos con los filtros  ***********************/
  /******************************************************************************/

  //filtramos por marcas
  const HeanddleFilterBrandData = (name: string, checked: boolean) => {
    setSelectBrandFilter((prev) =>
      checked ? [...prev, name] : prev.filter((brands) => brands !== name)
    );
  };

  //filtramos por orden de precio
  const HeanddleOrderToFilter = (event: number) => {
    setOrderToColumnFilter(event);
  };

  //filtramos por rango de precio
  const HeaddleRangePriceFilter = useCallback((min: number, max: number) => {
    setDataRangeFilter([min, max]);
  }, []);

  // *** Filtramos los datos pr cada sección **
  // -- 1 ) Filtrado por coincidencia (marca, categoría, etc.)
  const filterForBrand = useMemo(() => {
    //verificamos que si contegamos datos.
    if (!ProductsForCategory || ProductsForCategory.length === 0) return [];

    // devolvemos si no tenemos seleccionado ningun dato
    if (SelectBrandFilter.length === 0) return ProductsForCategory;

    //filtramos todos los datos posibles que coincidan.
    return ProductsForCategory.filter((item) =>
      SelectBrandFilter.includes(item.Brand.trim().toLocaleLowerCase())
    );
  }, [ProductsForCategory, SelectBrandFilter]);

  // -- 2 ) Filtrado por rango
  const FilterForRange = useMemo(() => {
    //verificamos que si contegamos datos.
    if (!ProductsForCategory || ProductsForCategory.length === 0) return [];

    //obtenemos el rango requerido
    const [min, max] = dataRangeFilter;

    //retornamos los datos que entre entre ese rango establedico
    return filterForBrand.filter((item) => {
      const values = Number(item["Price"]) || 0;
      return values >= min && values <= max;
    });
  }, [filterForBrand, dataRangeFilter]);

  // -- 3 ) Ordenamiento (mayor a menor, menor a mayor, etc.)
  const orderForData = useMemo(() => {
    //verificamos que si contegamos datos.
    if (!ProductsForCategory || ProductsForCategory.length === 0) return [];

    //ingresamos los datos para que sean ordenadas segun su :
    const sortedProducts = [...FilterForRange];
    switch (OrderToColumnFilter) {
      case 1:
        return sortedProducts.sort((a, b) => b["Price"] - a["Price"]);
      case 2:
        return sortedProducts.sort((a, b) => a["Price"] - b["Price"]);
      case 3:
        return sortedProducts.sort(
          (a, b) => b["CBvAverageRating"] - a["CBvAverageRating"]
        );
      default:
        return [...FilterForRange];
    }
  }, [FilterForRange, OrderToColumnFilter]);

  //se envia los datos para mostrar todo los productos ya filtrados.
  const ProductsForCategoryFilter = orderForData;

  //se vuelve por defecto si se hace cambios de sub-categoria
  useEffect(() => {
    //limpiamos las variable de estado.
    setSelectBrandFilter([]); //brand - marca
    setDataRangeFilter([0, 50500]); // range - rango
    setOrderToColumnFilter(0); //order to column - orderna segun su tipo.
  }, [cteg, subcateg]);

  return (
    <CategoriesContext.Provider
      value={{
        IsLoadings,
        ProductsByCategory,
        ProductsForCategory,
        ProductColorsCategory,
        SelectBrand,
        SelectBrandFilter,
        ProductsForCategoryFilter,
        HabilitedFilters,
        VoidDefault,
        HeanddleFilterBrandData,
        HeanddleOrderToFilter,
        HeaddleRangePriceFilter,
      }}>
      {children}
    </CategoriesContext.Provider>
  );
};

export default ContextCategorieProvider;

export const useConatextCategoriesData = () => {
  const context = useContext(CategoriesContext);
  if (!context)
    throw new Error(
      "useConatextCategoriesData must be used within a ContextCategorieProvider"
    );

  return context;
};
